import * as actionTypes from "../actionTypes";

export const getReport = function (payload) {
  return {
    type: actionTypes.GET_REPORT,
    payload: payload,
  };
};
